import {Component, Input, OnInit} from '@angular/core';
import {Information} from "../information";

@Component({
  selector: 'app-information-program',
  templateUrl: './information-program.component.html',
  styleUrls: ['./information-program.component.css']
})
export class InformationProgramComponent  {
  @Input() information: Information;

  constructor() {
    this.information = new Information();
  }
}
